export const features = {
  directory: true,
  giveBack: false,
  joinNow: false,
  chaptersPage: false,
};
